
import Navbar  from './Navbar'
import Portfolios from './Portfolios';
import Stocks from './Stocks';
import StockDetails from './StockDetails';
import Contact from './pages/Contact';

import {BrowserRouter, Routes, Route} from 'react-router-dom'

function App() {

  return (   
    <div className="App">
      <BrowserRouter>
          <Navbar/>
            <Routes>
              <Route path="/" element={<Stocks/>}/>
              <Route path="/stocks" element={<Stocks/>}/>
              <Route path="/stock/:ticker" element={<StockDetails />}/>
              <Route path="/portfolios" element={<Portfolios/>}/>
              <Route path="/contact" element={<Contact/>}/>
            </Routes>          
        </BrowserRouter>
      </div>
  );
}

export default App;
